<mat-dialog-content>
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div matDialogTitle i18n>Upload Documents</div>
    <button mat-icon-button class="close" [disabled]="uploadsInProgress" (click)="dialogRef.close()">
      <span class="close"><mat-icon>close</mat-icon></span>
    </button>
  </div>
  <div class="body">
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="drop-container"
      ivCustomFileDrop [options]="options"
      (uploadOutput)="onUploadOutput($event)"
      [uploadInput]="uploadInput"
      [ngClass]="{ 'is-drop-over': dragOver }">
      <p i18n>Drag and drop your document here to upload</p>
    </div>

    <div>
      <span i18n>or choose file(s) to</span>
      <label class="upload-button">
        <span i18n>upload</span>
        <input type="file"
          class="file-upload"
          ivFileSelect
          [options]="options" (uploadOutput)="onUploadOutput($event)"
          [uploadInput]="uploadInput" multiple  #file>
      </label>
    </div>
    <div class="file-list">
      <div *ngFor="let file of files" class="file-item-success" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="file-name"> {{ file.name }}</div>
        <mat-progress-spinner *ngIf="file.progress.status !== 2" color="primary" mode="indeterminate"></mat-progress-spinner>
        <span *ngIf="file.progress.status === 2 && !isError(file)" class="icon-wrapper"><mat-icon>check</mat-icon></span>
        <span *ngIf="isError(file)" class="icon-wrapper error"><mat-icon>error</mat-icon></span>
      </div>
      <div *ngFor="let rejectedFile of rejectedFiles" class="file-item-unsupported" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="file-name">
          <span i18n>Unsupported file:</span> {{ rejectedFile.name }}
        </div>
        <span class="icon-wrapper error"><mat-icon>error</mat-icon></span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
  <div>
    <button class="nav-button" mat-button [disabled]="uploadsInProgress" (click)="dialogRef.close()" fxFlex i18n>Done</button>
  </div>
</mat-dialog-actions>
